class ProductAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.accordionHeading = this.querySelector('.accordion__header');
    this.accordionContent = this.querySelector('.accordion__content');
    this.accordion = this.querySelector('.accordion');
    this.accordionHeading.addEventListener('click', this.toggleContent.bind(this));
  }

  toggleContent(e) {
    if (!this.accordionContent || !this.accordion ) return;

    this.accordionHeading.classList.toggle('is-open');

    this.accordion.classList.toggle('is-open');
    const isExpanded = this.accordion.getAttribute('aria-expanded') === 'true';
    this.accordion.setAttribute("aria-expanded", String(!isExpanded));

    this.accordionContent.style.maxHeight
      ? (this.accordionContent.style.maxHeight = null)
      : (this.accordionContent.style.maxHeight = this.accordionContent.scrollHeight + 'px');
  }
}

customElements.define('product-accordion', ProductAccordion);